export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const SET_APPLICATION_STATUS = 'SET_APPLICATION_STATUS';
export const SET_APP_STATE = 'SET_APP_STATE';
export const SET_DEFAULT_PRINTER = 'SET_DEFAULT_PRINTER';
export const SET_SUPPLIERID = 'SET_SUPPLIERID';
